import { render, staticRenderFns } from "./RolesWidget.vue?vue&type=template&id=3bf45ff5&"
import script from "./RolesWidget.vue?vue&type=script&lang=js&"
export * from "./RolesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports